var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isPermission && _vm.isIncludeStatus ? _c('div', {
    class: _vm.page == 'list' ? 'mr-2' : ''
  }, [_vm.buttonTemplate == 'member_button' ? _c('div', [_c('MemberButton', {
    attrs: {
      "button-text": _vm.statusMessage,
      "type": _vm.buttonAction
    }
  })], 1) : _vm.buttonTemplate == 'shared_button' ? _c('div', [_c('SharedButton', {
    class: _vm.statusClass,
    attrs: {
      "variant": _vm.statusVariant
    },
    on: {
      "click": _vm.clickAction
    }
  }, [_c('i', {
    class: _vm.statusIcon
  }), _vm._v(" " + _vm._s(_vm.statusMessage) + " ")])], 1) : _vm.buttonTemplate == 'inform_button' ? _c('div', [_c('InformButton', {
    class: _vm.statusClass,
    attrs: {
      "variant": _vm.statusVariant
    },
    on: {
      "click": _vm.clickInformButtonAction
    }
  }, [_c('i', {
    class: _vm.statusIcon
  }), _vm._v(" " + _vm._s(_vm.statusMessage) + " ")])], 1) : _c('div', [_c('b-button', {
    class: _vm.statusClass,
    attrs: {
      "variant": _vm.statusVariant
    },
    on: {
      "click": _vm.clickAction
    }
  }, [_c('i', {
    class: _vm.statusIcon
  }), _vm._v(" " + _vm._s(_vm.statusMessage) + " ")])], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }